import axios from "axios";

// Le frontend (gymtrack-aia.pages.dev) et le backend (*.run.app) sont sur deux
// domaines différents : le cookie de session est un cookie tiers, bloqué par
// défaut par Safari/Firefox et par la protection anti-pistage de Chrome, même
// avec SameSite=None; Secure. On transporte donc le JWT dans l'en-tête
// Authorization, et on garde withCredentials pour le cas same-site.
const TOKEN_KEY = "gt_access_token";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null;
  }
}

export function setToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    console.warn("Stockage du token impossible:", e?.message);
  }
}

export function clearToken() {
  setToken(null);
}

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401) {
      clearToken();
      if (!url.includes("/auth/") && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
